"use strict";
import constants from "../../constants";

function actionTabList(newActiveTabID, url) {

    $.ajax({
        url: url,
        type: "post",
        dataType: "json",
        data: {
            newActiveTabID: newActiveTabID,
        },
        success: (data) => {
            const { success, redirectUrl } = data;

            if (success) {
                location.href = redirectUrl;
            }
        },
        error: (error) => {
            if (error.responseJSON && error.responseJSON.redirectUrl) {
                window.location.href = error.responseJSON.redirectUrl;
            }
        },
    });
}

const initializeHeaderTabList = () => {
    const headerTabList         = $(".js-header-tab");
    const headerTabListMobile   = $(".js-mobile-header-tab-select");
    const headerTabOptionButton = $(".js-tab-option-button");
    const mobileSelectBar       = $(".js-mobile-select-bar");
    const mobileSelectClose     = $(".js-mobile-select-close");

    const preventBodyScroll = () => {
        $("body").css("overflow", "hidden");
    };

    const allowBodyScroll = () => {
        $("body").css("overflow", "");
    };

    const closeMobileSelectBar = () => {
        if (mobileSelectBar.length) {
            mobileSelectBar.removeClass("is-open");
        }

        if (headerTabOptionButton.length) {
            headerTabOptionButton.attr("aria-expanded", "false");
        }

        allowBodyScroll();
    };

    const closeHamburgerMenuIfOpen = () => {
        const $hamburgerToggler = $(".mobile-menu-toggler.opened");

        if ($hamburgerToggler.length) {
            $hamburgerToggler.trigger("click");
        }
    };

    const closeSelectCityModal = () => {
        const $selectCityToggle = $(".js-toggle-select-city");

        if (!$selectCityToggle.length) {
            return;
        }

        $selectCityToggle.removeClass("open");

        document.body.style.overflow = "auto";
    }

    const openMobileSelectBar = () => {
        closeHamburgerMenuIfOpen();
        closeSelectCityModal();

        if (mobileSelectBar.length) {
            mobileSelectBar.addClass("is-open");
        }

        if (headerTabOptionButton.length) {
            headerTabOptionButton.attr("aria-expanded", "true");
        }
    };

    headerTabList.each((index, headerTab) => {
        const $headerTab = $(headerTab);

        $headerTab.on("click", (event) => {
            const $target              = $(event.target);
            const isInsideMenuDropdown = $target.closest(".categories").length > 0 ||
                                        $target.closest(".main-menu").length > 0;

            if (isInsideMenuDropdown) {
                return;
            }

            event.preventDefault();
            const newActiveTabID = $headerTab.attr("id");
            const url            = $headerTab.attr("action") || $headerTab.attr("href");

            if (mobileSelectBar.is(":visible")) {
                closeMobileSelectBar();
            }

            actionTabList(newActiveTabID, url);
        });

        $headerTab.on("keypress", (event) => {
            if (event.keyCode === constants.KEYBOARD_KEYS.ENTER) {
                $headerTab.trigger("click");
            }
        });
    });

    headerTabOptionButton.on("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (mobileSelectBar.hasClass("is-open")) {
            closeMobileSelectBar();
        } else {
            openMobileSelectBar();
        }
    });

    mobileSelectClose.on("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        closeMobileSelectBar();
    });

    $(document).on("click", (event) => {
        if (mobileSelectBar.is(":visible") &&
            !$(event.target).closest(".mobile-select-bar, .js-tab-option-button").length) {
            closeMobileSelectBar();
        }
    });

    headerTabListMobile.each((index, headerSelect) => {
        $(headerSelect).on("change", () => {
            const newActiveTabID = $(headerSelect).val();
            const url            = $(headerSelect).find(`[value=${newActiveTabID}]`).attr("action");

            actionTabList(newActiveTabID, url);
        });
    });
};

export default initializeHeaderTabList;
